<template>
    <v-card
        elevation="2"
        outlined
        class="pa-5"
    >
        <v-card-title>Priority Type Category</v-card-title>
        <v-data-table
            :headers="headers"
            :items="priorities"
            item-key="code"
            class="row-pointer"
            @click:row="filterPriorityTypeCategory"
        >
            <template v-slot:[`item.priority`]="{ item }">
                <v-icon :color="item.color">
                    {{ item.iconName }}
                </v-icon>
                {{ item.priority }}
            </template> 
        </v-data-table>
    </v-card>
</template>
<script>
import   {setPriorityTypeCategoryFilter}  from '../services/ticketTabs';
export default {
    props: {
        priorityData: {
            type: Array,
            required: true,
            default: () => []
        },
    },
    data() {
        return {
            priorityIcons: {
                EMER: {
                    iconName: 'notification_important',
                    color: '#FF0000',
                },
                NORM: {
                    iconName: 'error',
                    color: '#7F8592',
                },
                RUSH: {
                    iconName: 'error',
                    color: '#FDD835',
                },
                INSF: {
                    iconName: 'error',
                    color: '#7F8592',
                },
                ROUT: {
                    iconName: 'error',
                    color: '#7F8592',
                },
                ENGR: {
                    iconName: 'error',
                    color: '#7F8592',
                },
                REMK: {
                    iconName: 'error',
                    color: '#7F8592',
                },
                SHRT: {
                    iconName: 'error',
                    color: '#7F8592',
                },
                NONC: {
                    iconName: 'error',
                    color: '#7F8592',
                },
            },
            headers: [
                {
                    text: 'Priority',
                    value: 'priority',
                },
                {
                    text: 'Type',
                    value: 'type',
                },
                {
                    text: 'Category',
                    value: 'category',
                },
                {
                    text: 'Total Tickets',
                    value: 'count',
                    align: 'end',
                },                
            ],
        };
    },
    computed: {
        priorities() {
            return this.priorityData.map(priority => {
                // Don't mutate the passed in prop priorityData
                // make a new object with {}
                return Object.assign({}, priority, this.priorityIcons[priority.priority]);
            });
        }
    },
    methods: {
        filterPriorityTypeCategory(item) {            
            setPriorityTypeCategoryFilter(item.priority,item.type,item.category);
        }
    },
};

</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
